window.optionsbase = {
    chart: {
        type: 'bar',
        height: 240,
        toolbar: {show: false},
    },

    plotOptions: {
        bar: {
            barHeight: '90%',
            distributed: true,
            horizontal: true,
            dataLabels: {
                position: 'bottom'
            },
        }
    },
    tooltip: {
        y: {
            formatter: function (value, {series, seriesIndex, dataPointIndex, w}) {
                return value.toFixed() + "%"
            }
        }
    },
    xaxis: {
        labels: {
            formatter: function (value) {
                return value + '%';
            }
        }
    },
    series: [{
        name: `Answers`,  //Answer for survey
    }],
    colors: constants.colors,
    legend: {
        show: false
    },
    dataLabels: {
        enabled: true,
        textAnchor: 'start',
        formatter: function (val, opt) {
            return val.toFixed() + '%'
        },
        offsetX: 0,
        dropShadow: {
            enabled: true
        }
    },
}
